import React, { useEffect } from 'react';
import { formatCurrency, formatCurrencyShort } from '../utils/currency';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Preloader from '../components/Preloader';
import ScrollToTop from '../components/ScrollToTop';
import PageTitle from '../components/PageTitle';

const gallery = [
  { img:'/images/gw/exterior/exterior-front.jpg',     label:'Event Hall' },
  { img:'/images/gw/exterior/exterior-side.jpg',       label:'Hotel Gardens' },
  { img:'/images/gw/facilities/reception-staff.jpg',   label:'Reception Desk' },
  { img:'/images/gw/facilities/lobby-lounge.jpg',      label:'Reception Lobby' },
  { img:'/images/gw/rooms/room-standard.jpg',          label:'Greatwood Standard' },
  { img:'/images/gw/rooms/room-executive.jpg',         label:'Greatwood Executive' },
  { img:'/images/gw/rooms/room-special.jpg',           label:'Greatwood Special' },
  { img:'/images/gw/rooms/suite-sitting.jpg',          label:'Presidential Suite' },
  { img:'/images/gw/facilities/swimming-pool.jpg',     label:'Swimming Pool' },
  { img:'/images/gw/facilities/event-hall.jpg',        label:'Event Hall' },
  { img:'/images/gw/facilities/boardroom.jpg',         label:'Boardroom' },
  { img:'/images/gw/facilities/bar-lounge.jpg',        label:'Bar & Lounge' },
];

export default function Pricing() {
  useEffect(() => {
    Fancybox.bind('[data-fancybox="gw-gallery"]', {});
    return () => Fancybox.unbind('[data-fancybox="gw-gallery"]');
  }, []);

  return (
    <div className="page-wrapper">
      <Preloader />
      <Header />
      <PageTitle title="Photo Gallery" breadcrumbs={[{ label:'Gallery' }]} />

      <section style={{ padding:'64px 0' }}>
        <div className="auto-container">

          <div style={{ display:'flex', alignItems:'flex-end', justifyContent:'space-between', marginBottom:36, flexWrap:'wrap', gap:16 }}>
            <div>
              <span className="h2-label">Take a Look</span>
              <h2 style={{ fontFamily:'var(--gw-font-h,serif)', fontSize:'clamp(26px,3.2vw,44px)', color:'#111', lineHeight:1.15, margin:'8px 0 0' }}>
                Greatwood Hotel in Pictures
              </h2>
            </div>
            <Link to="/contact" className="h2-btn-primary">Book a Stay</Link>
          </div>

          <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:14 }}>
            {gallery.map((g,i) => (
              <a
                key={i}
                href={g.img}
                data-fancybox="gw-gallery"
                data-caption={g.label}
                style={{ position:'relative', display:'block', overflow:'hidden', borderRadius:6, height:200, textDecoration:'none' }}
              >
                <img src={g.img} alt={g.label} style={{ width:'100%', height:'100%', objectFit:'cover', display:'block', transition:'transform 0.4s ease' }}
                  onMouseEnter={e => e.currentTarget.style.transform='scale(1.07)'}
                  onMouseLeave={e => e.currentTarget.style.transform='scale(1)'} />
                <div style={{ position:'absolute', inset:0, background:'linear-gradient(to top, rgba(0,0,0,0.55), transparent 60%)', display:'flex', alignItems:'flex-end', padding:12 }}>
                  <span style={{ color:'#fff', fontSize:12, fontWeight:700, letterSpacing:0.5 }}>{g.label}</span>
                </div>
              </a>
            ))}
          </div>

        </div>
      </section>

      <Footer />
      <ScrollToTop />
    </div>
  );
}
